import { Text } from "@chakra-ui/react";
import React from "react";

export interface PageInstructionsProps {
  children: string;
}

export const PageInstructions: React.FC<PageInstructionsProps> = ({
  children,
}) => (
  <Text textStyle="small" mb="8px" color="gray.600">
    {children}
  </Text>
);
